export default __webpack_public_path__ + "images/81ae4c213ea5dba05145ad6f301446a6.png";